import styled from 'styled-components'

export const TagContainer = styled.div`
  display: flex;
  max-width: 11cm;
  max-height: 9cm;
  width: 11cm;
  height: 9cm;
  flex-direction: column;
  background-color: #000;
  padding: 5px;
  -webkit-print-color-adjust: exact;
`

export const Text = styled.p`
  margin: 0;
  padding: 0;
  text-align: center;
  font-size: ${({ size = 16 }) => `${size}px`};
  font-weight: bold;
`

export const DescriptionText = styled(Text)`
  max-width: 300px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`

export const ContainerInfo = styled.div`
  background-color: #fff;
  display: flex;
  flex: 1;
  flex-direction: 'row';
  justify-content: space-around;
  align-items: center;
  margin: 2px;
`

export const ContainerTitle = styled(ContainerInfo)`
  background-color: #000;
  & > p:nth-child(n) {
    color: #fff;
    font-size: 20px;
  }
`

export const ContainerBatchId = styled(ContainerInfo)`
  flex: 2;
  flex-direction: column;
`

export const ContainerAddress = styled(ContainerInfo)`
  display: flex;
  flex-direction: column;
  background-color: #000;
  & > p:nth-child(n) {
    color: #fff;
  }
`

export const AddressBlock = styled.div`
  display: flex;
  flex-direction: row;
  background-color: #000;
  & > p:nth-child(n) {
    color: #fff;
  }
`
